import React from "react";
import { OvalSpinner } from "../../../../components/shared/OvalSpinner";
import { ToggleButton } from "primereact/togglebutton";
import { Link } from "react-router-dom";

export const COLUMNS = ({
  loading,
  t,
  onDeviceStatusChange,
  name,
  taxNumber,
  onCustomerPriceStatusChange,
  onSummayInvoiceStatusChange,
}) => [
  {
    field: "name",
    header: t("admin_control.name"),
    sortable: false,
    body: () => (
      <Link className={"nameCol"} to={`/taxpayers?tin=${taxNumber}`}>
        {name}
      </Link>
    ),
  },
  {
    field: "taxNumber",
    header: t("admin_control.tin"),
    sortable: true,
    body: () => <span>{taxNumber}</span>,
  },
  {
    field: "activityNumber",
    header: t("admin_control.incomeSerialNumber"),
    sortable: true,
    body: undefined,
  },
  {
    field: "active",
    header: t("admin_control.enableDisableIntegration"),
    sortable: false,
    body: (rowData) =>
      loading[rowData?.activityNumber] ? (
        <OvalSpinner width={35} height={35} />
      ) : (
        <ToggleButton
          checked={rowData.active}
          onChange={(e) => onDeviceStatusChange(e, rowData)}
          onIcon="pi pi-enabled"
          offIcon="pi pi-disabled"
          onLabel=""
          offLabel=""
        />
      ),
  },
  {
    field: "customerPriceEnabled",
    header: t("admin_control.enableDisableCustomerPrice"),
    sortable: false,
    body: (rowData) =>
      loading[rowData?.activityNumber] ? (
        <OvalSpinner width={35} height={35} />
      ) : (
        <ToggleButton
          checked={rowData.customerPriceEnabled}
          onChange={(e) => onCustomerPriceStatusChange(e, rowData)}
          onIcon="pi pi-enabled"
          offIcon="pi pi-disabled"
          onLabel=""
          offLabel=""
        />
      ),
  },{
    field: "SummaryInvoiceEnabled",
    header: t("admin_control.enableDisableSummaryInvoice"),
    sortable: false,
    body: (rowData) =>
      loading[rowData?.activityNumber] ? (
        <OvalSpinner width={35} height={35} />
      ) : (
        <ToggleButton
          checked={rowData.summaryInvoiceEnabled}
          onChange={(e) => onSummayInvoiceStatusChange(e, rowData)}
          onIcon="pi pi-enabled"
          offIcon="pi pi-disabled"
          onLabel=""
          offLabel=""
        />
      ),
  },
];
